export default __webpack_public_path__ + "static/media/Risques pour la protection du patrimoine IMMATÉRIEL.755f1e13.svg";